import axios from "axios";

const isDevelopment = process.env.VUE_APP_ENV === "development";

const BASE_URL = isDevelopment
  ? process.env.VUE_APP_API_URL
  : "https://used.hyundai.ie/api/v1/car/";

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

export const usedCarsAPI = () =>
  axios.create({
    baseURL: BASE_URL
  });

export const CAR_OFFERS_URL = "ad/";
export const MAX_PRICE_RANGE = "ad/price-range/";
export const COUNTY_LIST_URL = "region/";
export const BOOK_TEST_DRIVE = carID => `ad/${carID}/book-test-drive/`;
export const CALCULATE_FINANCE_QUOTE = carID =>
  `ad/${carID}/calculate-finance-quote/`;
export const SEND_FINANCE_QUOTE = carID => `ad/${carID}/send-finance-quote/`;
export const DEALER_MICRO_SITE = dealerName => `sellers/${dealerName}`;
